"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookerParticipantType = exports.ParticipantioStatus = exports.EventParticipantType = exports.EventInviteStatus = exports.EventPrivacy = void 0;
var EventPrivacy;
(function (EventPrivacy) {
    EventPrivacy["INVITED_ONLY"] = "INVITED_ONLY";
    EventPrivacy["PUBLIC"] = "PUBLIC";
})(EventPrivacy = exports.EventPrivacy || (exports.EventPrivacy = {}));
var EventInviteStatus;
(function (EventInviteStatus) {
    EventInviteStatus["PENDING"] = "PENDING";
    EventInviteStatus["ACCEPTED"] = "ACCEPTED";
    EventInviteStatus["DECLINED"] = "DECLINED";
})(EventInviteStatus = exports.EventInviteStatus || (exports.EventInviteStatus = {}));
var EventParticipantType;
(function (EventParticipantType) {
    EventParticipantType["ORGANIZER"] = "ORGANIZER";
    EventParticipantType["TRAVELER"] = "TRAVELER";
})(EventParticipantType = exports.EventParticipantType || (exports.EventParticipantType = {}));
var ParticipantioStatus;
(function (ParticipantioStatus) {
    ParticipantioStatus["VIRTUAL_PENDING"] = "VIRTUAL_PENDING";
    ParticipantioStatus["REALLY_PENDING"] = "REALLY_PENDING";
    ParticipantioStatus["DECLINED"] = "DECLINED";
    ParticipantioStatus["ACCEPTED"] = "ACCEPTED";
})(ParticipantioStatus = exports.ParticipantioStatus || (exports.ParticipantioStatus = {}));
var BookerParticipantType;
(function (BookerParticipantType) {
    BookerParticipantType["FOR_ALL"] = "FOR_ALL";
    BookerParticipantType["SELF_ONLY"] = "SELF_ONLY";
    BookerParticipantType["CANNOT_BOOK"] = "CANNOT_BOOK";
})(BookerParticipantType = exports.BookerParticipantType || (exports.BookerParticipantType = {}));
